export enum MappingTab {
    Categories = 'categories',
    Units = 'units',
    Attributes = 'attributes',
}
